import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";

const TOAST_OPTIONS = {
  className: "sonner-toast",
  style: {
    background: "#1A1A1A",
    color: "#FDFBF7",
    border: "1px solid rgba(176,136,99,0.35)",
    borderRadius: 0,
    fontFamily: "'Manrope', sans-serif",
    fontSize: 13,
    letterSpacing: "0.02em",
  },
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
      </LanguageProvider>
    </div>
  );
}

export default App;
